<div class="grid" *ngIf="myWorkflowCalendar">
    <div class="relative col-12">
        <mat-accordion *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('t1')"
                    (closed)="onTabClose('t1')"
                    [expanded]="TabStates?.t1 == null || TabStates?.t1 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.t1 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txTeamleiter.teamCalender' | translate }}
                            </div>
                        </div>

                        <div class="absolute top-0 right-0 z-index-1000 pr-2 pt-2">
                            <div class="flex gap-2 items-center pe-1">
                                <div>
                                    <button mat-raised-button color="primary" *ngIf="!myTeamleaderState" (click)="toggleTeamleaderState(1); $event.stopPropagation()">
                                        <i class="fa fa-toggle-off mr-2"></i> {{ 'txTeamleiter.substituteOn' | translate }}
                                    </button>
                                    <button mat-raised-button color="accent" *ngIf="myTeamleaderState" (click)="toggleTeamleaderState(0); $event.stopPropagation()">
                                        <i class="fa fa-toggle-on mr-2"></i> {{ 'txTeamleiter.substituteOff' | translate }}
                                    </button>
                                </div>
                                <div *ngIf="reports$ | async as reports">
                                    <button
                                            mat-icon-button
                                            class="tx-pdf-button"
                                            color="accent"
                                            type="button"
                                            [disabled]="loadingReport"
                                            (click)="stopPropagation($event)"
                                            [matMenuTriggerFor]="reportMenu">
                                        <fa-icon *ngIf="!loadingReport" icon="file-pdf" class="large-icon"></fa-icon>
                                        <fa-icon *ngIf="loadingReport" icon="spinner" class="large-icon" [spin]="true"
                                                 disabled></fa-icon>
                                    </button>
                                    <mat-menu #reportMenu="matMenu">
                                        <button *ngFor="let report of reports" (click)="downloadReport(report)"
                                                mat-menu-item>
                                            {{ report.report_name }}
                                        </button>
                                    </mat-menu>
                                </div>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div *ngIf="myWorkflowCalendar == null">{{ 'txTeamleiter.processingData' | translate }}</div>
                    <div *ngIf="myWorkflowCalendar != null">
                        <tx-workflow-calendar
                                #txWorkflowCalendarComponent
                                *ngIf="myWorkflowCalendar"
                                [CalendarData]="myWorkflowCalendar"
                                [TeamLeader]="true"
                                [WfGroups]="wfGroups"
                                [showAllDataLoad]="true"
                                (OnRefresh)="getWorkflowCalendar(0)"
                                (OnClickLoadFullYear)="getWorkflowCalendar(1)"
                                (OnBusy)="calendarIsBusy = $event"
                                (OnGroupFilterChange)="onWorkflowGroupChange()"></tx-workflow-calendar>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

    </div>
</div>

<div class="grid">
    <div class="col-12">

        <mat-accordion
                *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('t2')"
                    (closed)="onTabClose('t2')"
                    [expanded]="TabStates?.t2 == null || TabStates?.t2 == true"
                    (mouseenter)="unwatchWorkflow()" (mouseleave)="watchWorkflow()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.t2 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txTeamleiter.requestsFromTeam' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div *ngIf="!myWorkflowHasData">{{ 'txTeamleiter.noRequestsAvailable' | translate }}</div>

                    <div *ngIf="myWorkflowHasData">
                        <div class="widget-body">
                            <div class="table-scroll" style="--tscroll-min: 820px">
                            <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-full table table-hover">
                                <ng-container matColumnDef="datum">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.date' | translate }}</th>
                                    <td mat-cell *matCellDef="let item">
                                        <div class="md:inline-block sm:flex sm:flex-column">
                                            <div>
                                                <ng-template [ngIf]="checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.from' | translate }}:</strong> {{ item.von | date: 'EE dd.MM.yyyy' }}<br/>
                                                </ng-template>
                                                <ng-template [ngIf]="!checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.on' | translate }}:</strong> {{ item.von | date: 'EE dd.MM.yyyy' }}<br/>
                                                </ng-template>
                                            </div>
                                            <div>
                                                <ng-template [ngIf]="checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.until' | translate }} :&nbsp;</strong>
                                                    {{ item.bis ? (item?.bis | date: 'EE dd.MM.yyyy') : '' }}
                                                </ng-template>
                                                <ng-template [ngIf]="!checkBisData(item.bis)">
                                                    <strong>{{ 'txTeamleiter.at' | translate }} :&nbsp;</strong>
                                                    {{ item?.von | formatTime: 'HH:mm' }}
                                                </ng-template>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="typ">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.type' | translate }}</th>
                                    <td mat-cell *matCellDef="let item">{{ item.Typname }}{{ item.TypNeu }}</td>
                                </ng-container>
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.name' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap">{{ item.Name }}</td>
                                </ng-container>
                                <ng-container matColumnDef="bearbeiter">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.editor' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap"><span [innerHTML]="item.Bearbeiter"></span></td>
                                </ng-container>
                                <ng-container matColumnDef="notiz">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.note' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap"><span [innerHTML]="item.NotizAntragssteller"></span></td>
                                </ng-container>
                                <ng-container matColumnDef="antwort">
                                    <th mat-header-cell *matHeaderCellDef>{{ 'txTeamleiter.answer' | translate }}</th>
                                    <td mat-cell *matCellDef="let item" class="wrap">
                                        <mat-form-field appearance="outline" class="w-full">
                                            <input matInput #notiz [(ngModel)]="workflowDataNote[item.id]"
                                                (focus)="unwatchWorkflow('input')"
                                                (blur)="!notiz.value && watchWorkflow('input')" type="text"
                                                autocomplete="new-password"
                                                [disabled]="item.art === 'FSC'"/>
                                        </mat-form-field>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let item">
                                        <ng-container *ngIf="item.art !== 'FSC'">
                                            <div class="flex flex-col mt-1">
                                                <button mat-raised-button color="primary" class="w-full mb-1"
                                                    (click)="onApproveClick(item, workflowDataNote[item.id])">
                                                    {{ 'txTeamleiter.agree' | translate }}
                                                </button>
                                                <button mat-raised-button color="warn" class="w-full"
                                                    (click)="onDeclineClick(item, workflowDataNote[item.id])">
                                                    {{ 'txTeamleiter.disagree' | translate }}
                                                </button>
                                            </div>
                                        </ng-container>
                                        <button mat-raised-button color="primary" *ngIf="item.art === 'FSC'"
                                            (click)="openFscDialog(extractIdFromInfo(item.info), item.typ)"
                                            class="w-full mt-1">
                                            {{ 'txTeamleiter.Check' | translate }}
                                        </button>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="expandedInfo">
                                    <td mat-cell *matCellDef="let item" [attr.colspan]="displayedColumns.length" class="wrap">
                                        <strong *ngIf="item.info">{{ 'txTeamleiter.info' | translate }}: </strong>
                                        <span *ngIf="item.info" [innerHTML]="item.info"></span>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"
                                    [ngClass]="{ 'border-bottom-none': row.info }"></tr>
                                <tr mat-row *matRowDef="let row; columns: expandedColumns; when: hasAlwaysInfoRow"
                                    class="detail-row"
                                    (mouseenter)="hoverBoth($event)" (mouseleave)="hoverBoth($event)"></tr>
                            </table>
                            </div>
                            <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>

<div class="grid">
    <div class="col-12">
        <mat-accordion
                *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('t5')"
                    (closed)="onTabClose('t5')"
                    [expanded]="TabStates?.t5 == null || TabStates?.t5 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.t5 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txTeamleiter.timeOverview' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <tx-time-sums-chart-tl
                            #txTimeSumsChartComponent
                            [WfGroups]="wfGroups"
                            [CalendarData]="myWorkflowCalendar"
                            [groupFilterTrigger]="groupFilterTrigger"></tx-time-sums-chart-tl>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>


<div class="grid">
    <div class="col-12">
        <mat-accordion
                *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('t6')"
                    (closed)="onTabClose('t6')"
                    [expanded]="TabStates?.t6 == null || TabStates?.t6 == true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.t6 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txTeamleiter.protocol' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <tx-teamleaderprotocol></tx-teamleaderprotocol>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>

